export type SidebarMenuItemType =
  | 'Undefined'
  | 'Route'
  | 'Heading'
  | 'Collapse'
  | 'Link'
  | 'DynamicLink';

export const SidebarMenuItemType = {
  Undefined: 'Undefined' as SidebarMenuItemType,
  Route: 'Route' as SidebarMenuItemType,
  Heading: 'Heading' as SidebarMenuItemType,
  Collapse: 'Collapse' as SidebarMenuItemType,
  Link: 'Link' as SidebarMenuItemType,
  DynamicLink: 'DynamicLink' as SidebarMenuItemType
};

export default SidebarMenuItemType;